var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.64 63.64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07 0L0 7.07l24.75 24.75L0 56.57l7.07 7.07 24.75-24.75 24.75 24.75 7.07-7.07-24.75-24.75L63.64 7.07 56.57 0 31.82 24.75z",
    "data-name": "Layer 1"
  }))));
}
export default __webpack_public_path__ + "static/svg/x.svg";
export { SvgX as ReactComponent };